export const iconFontAwesomeHumanitarianParachuteBox = (
	<i className="fa-solid fa-parachute-box"></i>
);
